/**
 * The step-up token (LLD §6.7): memory only, bound to the session, never in
 * storage. `get` answers only a token with at least 30 s left, so a request
 * never leaves with one that expires on the way.
 *
 * Task 1.1 needs it for TOTP enrolment; Task 1.4 builds the step-up dialog
 * and `useWithStepUp` on it, and the session's sign-out clears it (§6.3).
 */
export interface StepUp {
  token: string
  /** Epoch milliseconds. */
  expiresAt: number
}

const MARGIN_MS = 30_000
let current: StepUp | null = null

export const stepUpStore = {
  get(now: number = Date.now()): string | undefined {
    return current && current.expiresAt - now >= MARGIN_MS ? current.token : undefined
  },
  set(s: StepUp): void {
    current = s
  },
  clear(): void {
    current = null
  },
}
